import { render, staticRenderFns } from "./ConfirmationBuyerDetails.vue?vue&type=template&id=bb2bf65e&"
import script from "./ConfirmationBuyerDetails.vue?vue&type=script&lang=js&"
export * from "./ConfirmationBuyerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.vlaams-brabant/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormInput, BCol, BRow, BCard} from 'bootstrap-vue'
    installComponents(component, {BFormInput, BCol, BRow, BCard})
    

export default component.exports